import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronsUpDown, Check, Building2, Plus } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from '../../ui/command';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const VendorSelect = ({ value, onSelect }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    if (!open || vendors.length) return;
    fetch(`${API_URL}/api/admin/gastos/proveedores/autorizados`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } })
      .then(r => (r.ok ? r.json() : { vendors: [] }))
      .then(d => setVendors([...d.vendors].sort((a, b) => a.name.localeCompare(b.name, 'es'))));
  }, [open, vendors.length]);

  const known = vendors.some(v => v.name === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="expense-form-vendor"
          className="col-span-2 h-10 w-full rounded-md border border-input bg-background px-3 text-sm flex items-center justify-between gap-2 text-left">
          <span className={`truncate ${value ? 'text-gray-900' : 'text-gray-400'}`}>
            {value || 'Elegir proveedor…'}
            {value && vendors.length > 0 && !known && <span className="ml-1.5 text-[10px] font-bold text-amber-700 bg-amber-100 px-1.5 py-0.5 rounded">nuevo</span>}
          </span>
          <ChevronsUpDown size={14} className="text-gray-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[260px]" align="start">
        <Command>
          <CommandInput placeholder="Buscar proveedor…" data-testid="expense-form-vendor-search" />
          <CommandList className="max-h-64">
            <CommandEmpty>Ningún proveedor coincide</CommandEmpty>
            <CommandGroup>
              {vendors.map(v => (
                <CommandItem key={v.id} value={`${v.name} ${(v.aliases || []).join(' ')} ${(v.nifs || []).join(' ')}`}
                  onSelect={() => { onSelect(v); setOpen(false); }} data-testid={`expense-form-vendor-option-${v.id}`}>
                  <Check size={14} className={`mr-2 ${value === v.name ? 'opacity-100' : 'opacity-0'}`} />
                  <span className="truncate flex-1">{v.name}</span>
                  {v.nifs?.[0] && <span className="text-[10px] text-gray-400 ml-2">{v.nifs[0]}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
          <button type="button" onClick={() => navigate('/admin/gastos/proveedores')} data-testid="expense-form-vendor-manage"
            className="w-full border-t px-3 py-2.5 text-sm text-blue-700 flex items-center gap-2 hover:bg-blue-50">
            <Plus size={14} /> Añadir proveedor nuevo en Proveedores <Building2 size={13} className="ml-auto" />
          </button>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
